import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const attemptAction = createAsyncThunk(
    'attempt',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-missionattempts`)
            console.log("res-->",res)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const attemptSlice = createSlice({
    name: 'attempt',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(attemptAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(attemptAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(attemptAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const attemptReducer = attemptSlice.reducer
